export const locations = [
  {
    id: 'downtown',
    no: '01',
    name: 'Downtown',
    address: 'Address to be announced',
    status: 'Opening soon',
    hours: [
      { day: 'Mon – Thu', time: '11:30 – 22:00' },
      { day: 'Fri – Sat', time: '11:30 – 00:00' },
      { day: 'Sunday', time: '12:00 – 21:00' },
    ],
    image: 'https://readdy.ai/api/search-image?query=Interior%20of%20a%20gritty%20modern%20burger%20bar%20at%20night%20with%20open%20charcoal%20grill%20counter%2C%20warm%20amber%20light%2C%20pink%20neon%20accent%2C%20dark%20tiles%2C%20realistic%20editorial%20restaurant%20photography%2C%20soft%20film%20grain&width=900&height=600&seq=fc-loc-downtown&orientation=landscape',
  },
  {
    id: 'east-side',
    no: '02',
    name: 'East Side',
    address: 'Address to be announced',
    status: 'Opening soon',
    hours: [
      { day: 'Mon – Thu', time: '12:00 – 22:00' },
      { day: 'Fri – Sat', time: '12:00 – 23:30' },
      { day: 'Sunday', time: '12:00 – 21:00' },
    ],
    image: 'https://readdy.ai/api/search-image?query=Daylight%20street%20corner%20burger%20restaurant%20with%20large%20windows%2C%20wooden%20stools%2C%20people%20eating%20burgers%20inside%2C%20warm%20natural%20light%2C%20cream%20and%20pink%20painted%20walls%2C%20realistic%20editorial%20photography&width=900&height=600&seq=fc-loc-east&orientation=landscape',
  },
];